import { Wrapper } from '@ahmdigital/ui';
import React from 'react';

import AccordionSection from '../../../../../components/sections/accordion-section';
import data from './data';
import styles from './styles.module.sass';

const OtherSavings = () => (
  <Wrapper className={styles.wrapper}>
    <AccordionSection
      accordionId="tax-other-savings"
      items={data}
      title="Other ways you could save with health insurance"
      image={null}
    />
  </Wrapper>
);

export default OtherSavings;
